var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"action":_vm.preflightUrl,"method":"GET"}},[_c('input',{attrs:{"type":"hidden","name":"url"},domProps:{"value":_vm.redirectUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }